/**
 * DELAUR Drawer Functionality
 * Handles cart drawer, menu drawer, and cart updates
 */

document.addEventListener('DOMContentLoaded', () => {
  // Cart Drawer Logic
  const cartLink = document.querySelector('a[href*="cart"]');
  const cartTrigger = document.getElementById('cart-trigger');
  const cartDrawer = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');
  const closeCartBtn = document.querySelector('#cart-drawer .drawer-close');

  function openCart(e) {
    e.preventDefault();
    if (cartDrawer && cartOverlay) {
      // Refresh cart contents before opening
      refreshCart();
      cartDrawer.classList.add('active');
      cartOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeCart() {
    if (cartDrawer && cartOverlay) {
      cartDrawer.classList.remove('active');
      cartOverlay.classList.remove('active');
      document.body.style.overflow = '';
    }
  }

  if (cartLink) {
    cartLink.addEventListener('click', openCart);
  }

  if (cartTrigger) {
    cartTrigger.addEventListener('click', openCart);
  }

  if (closeCartBtn) closeCartBtn.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // Menu Drawer Logic
  const menuToggle = document.querySelector('.menu-toggle');
  const menuDrawer = document.getElementById('menu-drawer');
  const menuOverlay = document.getElementById('menu-overlay');
  const closeMenuBtn = document.querySelector('.menu-close');
  const menuLinks = document.querySelectorAll('.menu-link');

  function openMenu() {
    if (menuDrawer && menuOverlay) {
      menuDrawer.classList.add('active');
      menuOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeMenu() {
    if (menuDrawer && menuOverlay) {
      menuDrawer.classList.remove('active');
      menuOverlay.classList.remove('active');
      document.body.style.overflow = '';
    }
  }

  if (menuToggle) menuToggle.addEventListener('click', openMenu);
  if (closeMenuBtn) closeMenuBtn.addEventListener('click', closeMenu);
  if (menuOverlay) menuOverlay.addEventListener('click', closeMenu);

  // Accordion Logic for Menu Submenu
  menuLinks.forEach((link) => {
    link.addEventListener('click', function (e) {
      const submenu = this.nextElementSibling;
      if (submenu && submenu.classList.contains('submenu')) {
        e.preventDefault();
        submenu.classList.toggle('open');
        const span = this.querySelector('span');
        if (span) span.textContent = submenu.classList.contains('open') ? '-' : '+';
      }
    });
  });

  // Cart quantity update handlers
  function updateCartQuantity(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        line: line,
        quantity: quantity,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        refreshCart();
        updateCartCount(data.item_count);
      })
      .catch((error) => console.error('Error updating cart:', error));
  }

  function removeCartItem(line) {
    updateCartQuantity(line, 0);
  }

  function refreshCart() {
    fetch('/?sections=cart-drawer-delaur')
      .then((response) => response.json())
      .then((data) => {
        const cartContainer = document.getElementById('cart-drawer');
        if (cartContainer && data['cart-drawer-delaur']) {
          cartContainer.innerHTML = data['cart-drawer-delaur'];
          attachCartHandlers();
        }
      })
      .catch((error) => console.error('Error refreshing cart:', error));
  }

  function updateCartCount(count) {
    const cartTrigger = document.getElementById('cart-trigger');
    if (cartTrigger) {
      cartTrigger.textContent = `Cart (${count})`;
    }
  }

  function attachCartHandlers() {
    // Quantity buttons
    document.querySelectorAll('.qty-btn').forEach((btn) => {
      btn.addEventListener('click', function () {
        const line = parseInt(this.dataset.line);
        const action = this.dataset.action;
        const input = this.parentElement.querySelector('.qty-input');
        let quantity = parseInt(input.value);

        if (action === 'increase') {
          quantity++;
        } else if (action === 'decrease' && quantity > 1) {
          quantity--;
        }

        input.value = quantity;
        updateCartQuantity(line, quantity);
      });
    });

    // Quantity input change
    document.querySelectorAll('.qty-input').forEach((input) => {
      input.addEventListener('change', function () {
        const line = parseInt(this.dataset.line);
        const quantity = parseInt(this.value);
        if (quantity > 0) {
          updateCartQuantity(line, quantity);
        }
      });
    });

    // Remove buttons
    document.querySelectorAll('.cart-item-remove').forEach((btn) => {
      btn.addEventListener('click', function () {
        const line = parseInt(this.dataset.line);
        removeCartItem(line);
      });
    });

    // Reattach close button
    const newCloseBtn = document.querySelector('#cart-drawer .drawer-close');
    if (newCloseBtn) {
      newCloseBtn.addEventListener('click', closeCart);
    }
  }

  // Listen for custom cart refresh events
  document.addEventListener('cart:refresh', (e) => {
    refreshCart();
    if (e.detail && e.detail.open) {
      if (cartDrawer && cartOverlay) {
        cartDrawer.classList.add('active');
        cartOverlay.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
    }
  });

  // Initial cart handlers attachment
  attachCartHandlers();
});
